import { render, staticRenderFns } from "./CleanDashboard.vue?vue&type=template&id=338aef42&"
import script from "./CleanDashboard.vue?vue&type=script&lang=js&"
export * from "./CleanDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports